function Success() {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="8" cy="8" r="6" fill="#16973F"/>
            <path d="M5.52081 7.70833L7.27081 9.75L10.4791 6.25" stroke="white" strokeWidth="1.2"
                strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    );
}

export default Success;
